module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/flights_logo_bumper-d50e85578b4057f5acfd3ea9f695c3c1.jpg";